import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
    freelanceIncomePotentialContentSectionsPart1,
    freelanceIncomePotentialContentSectionsPart2,
    freelanceIncomePotentialContentSectionsPart3,
    freelanceIncomePotentialContentSectionsPart4,
    freelanceIncomePotentialContentSectionsPart5,
    freelanceIncomePotentialContentSectionsPart6,
    freelanceIncomePotentialContentSectionsPart7,
    freelanceIncomePotentialContentSectionsPart8,
    freelanceIncomePotentialContentSectionsPart9,
    popularFreelanceJobs
} from '../constant/freelance-income-potential-sections.constant';
import '../scss/freelance-income-potential.style.scss';
import {
    freelanceImage1,
    freelanceImage2,
    freelanceImage3,
    freelanceImage4,
    freelanceImage5,
    freelanceImage6,
    freelanceCTAImage
} from './images/jpg/freelanceIncomePotentialImage';

const FreelanceIncomePotentialPageComponent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="freelance-income-potential-page px-0">
            {/* Main Content Intro Section */}
            <section className="content-intro-section px-0">
                <Container>
                    <div className="content-intro-row px-0">
                        <div className="intro-left">
                            <h2 className="main-title">
                                {t("FREELANCE_INCOME_POTENTIAL_MAIN_TITLE")}
                            </h2>
                        </div>
                        <div className="intro-right">
                            <div className="main-description">
                                <p>{t('FREELANCE_INCOME_POTENTIAL_HERO_DESCRIPTION_PART_1')}</p>
                                <p>{t('FREELANCE_INCOME_POTENTIAL_HERO_DESCRIPTION_PART_2')}</p>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            {/* First Large Image */}
            <section className="freelance-image-section">
                <Container>
                    <img
                        src={freelanceImage1}
                        alt="Freelance Income"
                        className="large-image"
                    />
                </Container>
            </section>
              <section className="content-section">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart1[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                    <p>{t("UNDERSTANDING_FREELANCE_AND_CONSULTANT_FEES_DESCRIPTION")}</p>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Understanding Freelance and Consultant Fees */}
            <section className="content-section">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart2[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart2[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart2[1].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart2[1].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart2[2].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart2[2].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Second Large Image */}
            <section className="freelance-image-section">
                <Container>
                    <img
                        src={freelanceImage2}
                        alt="Setting Fees"
                        className="large-image"
                    />
                </Container>
            </section>

            {/* Two Column Content Section - How to set your fees */}
            <section className="two-column-content">
                <Container>
                    <div className="two-column-row">
                        <div className="left-column">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart3[0].titleKey)}
                            </h3>
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart3[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart3[1].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart3[1].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart3[2].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart3[2].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                        <div className="right-column">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart4[0].titleKey)}
                            </h3>
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart4[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart4[1].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart4[1].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart4[2].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart4[2].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Third Large Image */}
            <section className="freelance-image-section">
                <Container>
                    <img
                        src={freelanceImage3}
                        alt="Industry Fees"
                        className="large-image"
                    />
                </Container>
            </section>

            {/* Fees in Different Industries Section */}
            <section className="content-section">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart5[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart5[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart5[1].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart5[1].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart5[2].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart5[2].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Fourth Large Image */}
            <section className="freelance-image-section">
                <Container>
                    <img
                        src={freelanceImage4}
                        alt="Hourly Billing"
                        className="large-image"
                    />
                </Container>
            </section>

            {/* Hourly Billing Section */}
            <section className="content-section">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart6[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart6[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart6[1].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart6[1].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart6[2].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart6[2].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* List of Popular Freelance Jobs Introduction */}
          
            {/* Fifth Large Image */}
            <section className="freelance-image-section">
                <Container>
                    <img
                        src={freelanceImage5}
                        alt="Consulting Industry"
                        className="large-image"
                    />
                </Container>
            </section>

              <section className="content-section jobs-intro">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart7[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart7[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Popular Freelance Jobs Cards */}
            <section className="popular-jobs-cards">
                <Container>
                    <div className="jobs-cards-row">
                        {popularFreelanceJobs.map((job, index) => (
                            <div key={index} className="job-card-col">
                                <div className="job-card">
                                    <h3 className="job-title">
                                        {t(job.titleKey)}
                                    </h3>
                                    <div className="job-details">
                                        <p className="job-rate">{t(job.rateKey)}</p>
                                        <p className="job-description">{t(job.descriptionKey)}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>


            {/* Consulting Industry Section */}
            <section className="content-section">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart8[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart8[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Common Questions Section */}
            <section className="content-section">
                <Container>
                    <div className="content-row">
                        <div className="content-left">
                            <h3 className="section-title">
                                {t(freelanceIncomePotentialContentSectionsPart9[0].titleKey)}
                            </h3>
                        </div>
                        <div className="content-right">
                            <div className="section-content">
                                {freelanceIncomePotentialContentSectionsPart9[0].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart9[1].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart9[1].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}

                                <h4 className="subsection-title">
                                    {t(freelanceIncomePotentialContentSectionsPart9[2].titleKey)}
                                </h4>
                                {freelanceIncomePotentialContentSectionsPart9[2].textKeys.map((textKey, index) => (
                                    <p key={index}>{t(textKey)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

        </div>
    );
};

export default FreelanceIncomePotentialPageComponent;